export default function PromiseSection() {
  const promises = [
    {
      number: "01",
      title: "Quiet and Secure",
      body: "Located in a Private Marina, providing and added layer of comfort and security during your stay.",
    },
    {
      number: "02",
      title: "Direct Communication with the owner",
      body: "Direct contact with the owner — no third-party agents. Expect a reply within a few hours, morning to evening.",
    },
    {
      number: "03",
      title: "Flexible bookings",
      body: "Simple, transparent cancellation policies so you can book with confidence. Your stay, your terms.",
    },
  ];

  return (
    <section className="bg-[#FAFAF8] py-20 sm:py-28 border-y border-[#1C1C1A]/8">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16">

        <div className="text-center mb-14">
          <p className="eyebrow mb-4">The Aquastays Promise</p>
          <h2 className="font-serif text-3xl sm:text-4xl font-light text-[#1C1C1A] tracking-tight">
            We've done the hard work <em className="italic">for you.</em>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-0 border-l border-t border-[#1C1C1A]/8">
          {promises.map((p) => (
            <div key={p.number} className="p-8 sm:p-10 border-r border-b border-[#1C1C1A]/8">
              <p className="font-serif text-4xl font-light text-[#C8A96E] mb-6">{p.number}</p>
              <p className="font-medium text-[#1C1C1A] mb-3 text-sm uppercase tracking-[0.1em]">{p.title}</p>
              <p className="text-[#6B6B65] text-sm leading-relaxed font-light">{p.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
